import React from 'react';
import { X, Code2 } from 'lucide-react';

interface BadgeHeaderProps {
  onClose: () => void;
}

export const BadgeHeader: React.FC<BadgeHeaderProps> = ({ onClose }) => {
  return (
    <div className="p-3.5 sm:p-5 border-b border-slate-100 flex items-center justify-between bg-slate-50/80 gap-3">
      <div className="flex items-center gap-2.5 sm:gap-3 min-w-0 flex-1">
        <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-xl bg-indigo-600 text-white flex items-center justify-center shadow-xs shrink-0">
          <Code2 className="w-5 h-5" />
        </div>
        <div className="min-w-0 flex-1">
          <div className="flex items-center gap-2 flex-wrap">
            <h3 className="text-sm sm:text-base font-bold text-slate-900 leading-tight">
              Widget Verifikasi Tersemat
            </h3>
            <span className="px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-800 border border-emerald-200 shrink-0">
              Resmi UIBN
            </span>
          </div>
          <p className="text-xs text-slate-500 leading-snug mt-0.5">
            Sematkan lencana keaslian resmi pada situs web penerbit, toko buku online, atau portofolio penulis.
          </p>
        </div>
      </div>
      <button
        id="btn-close-embed-badge-modal"
        type="button"
        onClick={onClose}
        className="w-8 h-8 rounded-lg bg-slate-200/70 hover:bg-rose-100 text-slate-700 hover:text-rose-700 border border-slate-300 hover:border-rose-300 flex items-center justify-center transition cursor-pointer shrink-0 shadow-2xs"
        aria-label="Tutup Modal"
        title="Tutup (Esc)"
      >
        <X className="w-4.5 h-4.5 stroke-[2.2]" />
      </button>
    </div>
  );
};
